import React from 'react';
import { motion } from 'framer-motion';
export function FinalCTA() {
  const scrollToPricing = () => {
    document.getElementById('pricing-section')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="bg-brand-dark py-20 px-4 sm:px-6 lg:px-8 border-t border-white/5" data-id="element-75">
      <div className="max-w-2xl mx-auto text-center" data-id="element-76">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-77">
          <h2 className="text-2xl sm:text-3xl font-bold text-white mb-10 leading-tight" data-id="element-78">
            La próxima vez que abras un parcial, vas a estar preparado de
            verdad. 🧪
          </h2>

          <div className="w-full max-w-md mx-auto space-y-4 mb-8" data-id="element-79">
            <button onClick={scrollToPricing} className="w-full h-[56px] bg-brand-teal text-white font-bold rounded-xl text-lg shadow-lg hover:bg-brand-tealLight transition-all active:scale-[0.98] flex items-center justify-center gap-2" data-id="element-80">
              <span data-id="element-81">🧪</span> Quiero el BioKit Universitario
            </button>

            <button onClick={scrollToPricing} className="w-full h-[56px] bg-transparent border-2 border-white text-white font-semibold rounded-xl text-lg hover:bg-white/5 transition-all active:scale-[0.98] flex items-center justify-center gap-2" data-id="element-82">
              <span data-id="element-83">🚀</span> Quiero el BioKit + Extras
            </button>
          </div>

          <div className="flex justify-center items-center gap-3 text-sm text-gray-400 font-medium" data-id="element-84">
            <span data-id="element-85">✅ Garantía 7 días</span>
            <span data-id="element-86">·</span>
            <span data-id="element-87">🔒 Pago seguro</span>
            <span data-id="element-88">·</span>
            <span data-id="element-89">⚡ Acceso inmediato</span>
          </div>
        </motion.div>
      </div>
    </section>;
}